import {studyService} from "../services/study.service";

const useFavoriteCourse = async (card_id: string, isDelete: boolean = false) => {
    async function handleFavoriteChange(id: string) {
        if (isDelete) {
            await studyService.deleteFavorite((card_id))
        } else {
            await studyService.postFavorite({course_id: id})
        }
    }

    handleFavoriteChange(card_id).catch(error => console.log(error))
}

export default useFavoriteCourse